// src/utils/scoreHelp.js
export const scoreHelp = {
    win: {
      label: 'Win Score',
      calc: 'Emphasizes Jobs where importance and satisfaction are both high, scaled by evidence volume. It uses a (tempered) Harmonic lift algorithm.',
      meaning: 'Represents how strongly this job is a “win” for the product.',
    },
    gap: {
      label: 'Gap Score',
      calc: 'Importance-weighted gap: (importance − satisfaction), scaled to highlight bigger deficits on high-importance Jobs.',
      meaning: 'Represents opportunity—high scores mean customers care a lot but are not yet satisfied.',
    },
    impressionPos: {
      label: 'Positivity Score',
      calc: 'Average positive importance × mentions.',
      meaning: 'Represents how consistently this positive theme matters to users and how frequently it shows up.',
    },
    impressionNeg: {
      label: 'Negativity Score',
      calc: 'Average drawback importance × mentions.',
      meaning: 'Represents how consistently this negative theme matters and how frequently it’s raised.',
    },
    insightPos: {
      label: 'Positivity Score',
      calc: 'Average insight sentiment intensity × mentions (Positive only).',
      meaning: 'Represents positive themes users feel strongly about and mention often.',
    },
    insightNeg: {
      label: 'Opportunity Score',
      calc: 'Average insight sentiment intensity × mentions (Negative/Wish List only).',
      meaning: 'Represents problems or desires users feel strongly about and mention often.',
    },
    productWin: {
      label: 'Win Score',
      calc: 'Harmonic lift (tempered) using importance, satisfaction, and interview count.',
      meaning: 'Represents how strongly this product wins for the selected Job.',
    },
    productGap: {
      label: 'Gap Score',
      calc: 'Importance-weighted gap for the product on the selected Job.',
      meaning: 'Represents where this product under-delivers versus user importance.',
    },
  };
  